import { Component, EventEmitter, Input,  Output } from '@angular/core';
export interface CustomToolbarButton {
  name: string;
  label?: string;
  svg_icon: string;
  data?: any;
  dropdown?: any[]
}
@Component({
  selector: 'unh-custom-toolbar',
  templateUrl: './custom-toolbar.component.html',
  styleUrls: ['./custom-toolbar.component.scss']
})
export class CustomToolbarComponent  {
  editMode: boolean;
  activeDropdown: boolean;
  @Input() buttonsArray = []
  @Output() clickedButton = new EventEmitter();

  openDropDown(_button) {
    this.buttonsArray.map(button => {
      button.clicked = false;
      if (button.name == _button.name && button.dropdown) {
        button.clicked = true;
        this.activeDropdown = true;
        return button;
      }
    });

  }
  returnClickedButton(button) {
    this.removePopover();
    this.clickedButton.emit(button);
  }
  returnClickedDropdownButton(button) {
   this.clickedButton.emit(button)
  }

  removePopover() {
    const root = document.querySelector('unh-root');
    const popoverContentRefs = root.querySelectorAll('unh-popover-content');
    if (popoverContentRefs.length > 0) {
      popoverContentRefs.forEach(
        item => root.removeChild(item)
      )
    }
  }
}
